export default "__VITE_ASSET__a7107d6a__"